import React, { useState } from 'react';
import { Box, Popover, TextField, Typography } from '@mui/material';

const PRESETS = [
  '#ffffff', '#f8f9fa', '#e9ecef', '#dee2e6', '#adb5bd',
  '#6c757d', '#495057', '#343a40', '#212529', '#000000',
  '#e85d26', '#f97316', '#fbbf24', '#34d399', '#10b981',
  '#3b82f6', '#6366f1', '#8b5cf6', '#ec4899', '#ef4444',
];

const ColorSwatch = ({ color, selected, onClick }) => (
  <Box
    onClick={() => onClick(color)}
    sx={{
      width: 20,
      height: 20,
      borderRadius: '4px',
      background: color,
      border: selected ? '2px solid #1a1a1a' : '1px solid rgba(0,0,0,0.12)',
      cursor: 'pointer',
      flexShrink: 0,
      '&:hover': { transform: 'scale(1.15)', transition: 'transform 0.1s' },
    }}
  />
);

const ColorPickerPopover = ({
  anchorEl,
  open,
  onClose,
  value = '#000000',
  onChange,
  extraColors = [],
}) => {
  const [hex, setHex] = useState(value);

  const handleHexChange = (e) => {
    const v = e.target.value;
    setHex(v);
    if (/^#[0-9a-fA-F]{6}$/.test(v) || /^#[0-9a-fA-F]{3}$/.test(v)) {
      onChange(v);
    }
  };

  const handleSwatch = (color) => {
    setHex(color);
    onChange(color);
  };

  const allColors = [...new Set([...extraColors, ...PRESETS])];

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{ sx: { p: 1.5, width: 220, borderRadius: 2 } }}
    >
      {/* Native color input */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <input
          type="color"
          value={/^#[0-9a-fA-F]{6}$/.test(hex) ? hex : '#000000'}
          onChange={(e) => handleSwatch(e.target.value)}
          style={{ width: 32, height: 32, border: 'none', padding: 0, cursor: 'pointer', borderRadius: 4 }}
        />
        <TextField
          size="small"
          value={hex}
          onChange={handleHexChange}
          inputProps={{ style: { fontSize: 12, fontFamily: 'monospace', py: 0.5 } }}
          sx={{ flex: 1 }}
        />
      </Box>

      {extraColors.length > 0 && (
        <>
          <Typography variant="caption" sx={{ color: '#999', fontSize: 10, display: 'block', mb: 0.5 }}>
            Design system
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
            {extraColors.map((c) => (
              <ColorSwatch key={c} color={c} selected={hex === c} onClick={handleSwatch} />
            ))}
          </Box>
        </>
      )}

      <Typography variant="caption" sx={{ color: '#999', fontSize: 10, display: 'block', mb: 0.5 }}>
        Presets
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {PRESETS.map((c) => (
          <ColorSwatch key={c} color={c} selected={hex === c} onClick={handleSwatch} />
        ))}
      </Box>
    </Popover>
  );
};

export default ColorPickerPopover;
